import { Link } from "react-router-dom";
import { Container } from "../Container/Container";
export const NoMatch404 = () => {
    return (
        <Container>
            <p>There's nothing here: 404!</p>
            <Link to={`/`}>
              Home
            </Link>
        </Container>
    );
  };